"use client";

import { sectionHeadingClass, sectionIntroClass, sectionLabelClass } from "./typography";

type PageTitleProps = {
  label: string;
  title: string;
  intro?: string;
  lastUpdated?: string;
};

export function PageTitle({ label, title, intro, lastUpdated }: PageTitleProps): JSX.Element {
  return (
    <div className="mb-10 space-y-3">
      <p className={sectionLabelClass}>{label}</p>
      <h1 className={`${sectionHeadingClass} rtl:text-right`}>{title}</h1>
      {intro && <p className={`${sectionIntroClass} text-start rtl:text-right`}>{intro}</p>}
      {lastUpdated && <p className="text-sm text-slate-500 dark:text-slate-400">{lastUpdated}</p>}
    </div>
  );
}
